import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documenti',
  templateUrl: './documenti.component.html',
  styleUrls: ['./documenti.component.scss']
})
export class DocumentiComponent implements OnInit {

  listaCategorie: any = [
    {
      id : 1,
      descrizione : 'Rapporti di evento meteo - idrologici'
    },
    {
      id : 2,
      descrizione : 'Report'
    },
    {
      id : 3,
      descrizione : 'Poster'
    },
    {
      id : 4,
      descrizione : 'Opuscoli'
    },
    {
      id : 5,
      descrizione : 'Schede'
    },
    {
      id : 6,
      descrizione : 'Generali'
    },
    {
      id : 7,
      descrizione : 'Sistema di allertamento'
    },
    {
      id : 8,
      descrizione : 'Monografie'
    },
    {
      id : 9,
      descrizione : 'Rete dei Centri Funzionali'
    },
    {
      id : 10,
      descrizione : 'Normativa statale'
    },
    {
      id : 11,
      descrizione : 'Leggi regionali'
    },
    {
      id : 12,
      descrizione : 'Assetto organizzativo'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
